<template>
  <a-card size="small" :bordered="true" class="table-card">
    <template slot="title">{{ title }}</template>
    <template v-if="tooltip" slot="extra">
      <a-tooltip :title="tooltip">
        <span class="table-card__info">i</span>
      </a-tooltip>
    </template>

    <a-skeleton v-if="loading" active :paragraph="{ rows: 6 }" />
    <slot v-else />
  </a-card>
</template>

<script>
import { Skeleton } from 'ant-design-vue';

export default {
  name: 'TableCard',

  components: {
    'a-skeleton': Skeleton,
  },

  props: {
    title: { type: String, required: true },
    tooltip: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.table-card :deep(.ant-table-small) {
  font-size: 12px;
}

.table-card__info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #C8C1BA;
  color: #9C948C;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
}
</style>
